<template>
  <div style="width: 100%;">
    <!-- DESKTOP -->
    <VContainer id="with-background" fluid class="align-start d-none d-lg-block">
      <VRow>
        <VCol cols="12" md="6">
          <div class="d-flex mb-6 ml-16">
            <div class="pa-2 align-self-center">
              <VImg
                :src="handShaking"
                width="400"         
                class="d-block"      
                eager               
                contain             
              />
            </div>
          </div>
        </VCol>

        <VCol cols="12" md="6" class="d-flex justify-end">
          <div class="pa-2 align-self-center mr-16">
            <VCard color="transparent" class="elevation-0">
              <VCardText class="text-h4 font-weight-medium text-right text-white">
                {{ $t('WITH.question') }}
              </VCardText>
              <VCardText class="text-h6 font-weight-light text-right text-white" style="white-space: pre-line;">
                {{ $t('WITH.description') }}
              </VCardText>
              <VCardText class="text-h4 text-primary text-right mt-16" style="white-space: pre-line;">
                {{ $t('WITH.points') }}
              </VCardText>
            </VCard>
          </div>
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer id="with-background" fluid class="align-start d-md-none">
      <VRow>
        <VCol cols="12" md="6">
          <div class="d-flex">
            <div class="pa-2 align-self-center" style="width:100%;">
              <VImg
                contain
                :src="handShaking"
                :lazy-src="handShaking"
              />
            </div>
          </div>
        </VCol>

        <VCol cols="12" md="6" class="d-flex justify-center">
          <div class="pa-2 align-self-center" style="width:100%;">
            <VCard color="transparent" class="elevation-0">
              <VCardText class="text-h4 font-weight-medium text-center text-white">
                {{ $t('WITH.question') }}
              </VCardText>
              <VCardText class="text-h6 font-weight-light text-center text-white" style="white-space: pre-line;">
                {{ $t('WITH.description') }}
              </VCardText>
              <VCardText class="text-h6 text-primary text-center mt-16" style="white-space: pre-line;">
                {{ $t('WITH.points') }}
              </VCardText>
            </VCard>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </div>
</template>

<script>
import handShaking from '@/assets/imgs/hand_shaking.png'

export default {
  name: 'WithReportLake',
  data(){
    return{
        handShaking
    }
  }
};
</script>

<style>
body #with-background{
  background: rgb(255, 255, 255) url("../assets/imgs/with.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
